/* Reuse translated product HTML; split presentation wrappers into existing brick faces. */
(()=>{
 const rows=()=>{
 document.querySelectorAll('.product-recommendations--section,.recently-viewed--section').forEach(section=>{
  if(!section.classList.contains('pm-builder-page'))section.classList.add('pm-builder-page');
  const inner=section.querySelector('.product-recently-viewed__wrapper,.product-recommendations--container');if(inner&&!inner.classList.contains('pm-inner'))inner.classList.add('pm-inner');
  section.querySelectorAll('.product-recently-viewed__header,.product-recommendations--title,.productgrid--item').forEach(face=>{if(!face.classList.contains('pm-brick'))face.classList.add('pm-brick');});
 });
};
const build=()=>{rows();
 document.querySelectorAll('[data-pm-product-description]:not([data-pm-product-built])').forEach(root=>{
  root.dataset.pmProductBuilt='true';
  root.querySelectorAll('.pm-hero-logo,img[src*="logo_PeruMagazin"]').forEach(node=>node.remove());
  const output=document.createDocumentFragment();let face=null;
  const flush=()=>{face=null;};
  const add=node=>{if(!face){face=document.createElement('div');face.className='pm-brick pm-product-copy';output.append(face);}face.append(node);};
  const walk=parent=>{
   [...parent.childNodes].forEach(node=>{
    if(node.nodeType===3){if(node.textContent.trim())add(node);return;}
    if(node.nodeType!==1)return;
    if(node.matches('style'))return;
    if(node.matches('script,link')){output.append(node);return;}
    if(node.matches('div,section,article')){
     const grid=node.matches('.pm-product-grid,.pm-product-steps')||/display\s*:\s*grid/i.test(node.getAttribute('style')||'')||getComputedStyle(node).display==='grid';
     if(grid){flush();const row=document.createElement('div');row.className='pm-product-facts';row.dataset.columns=String((node.children.length===2||node.children.length===4)?2:3);[...node.children].forEach(item=>{item.removeAttribute('style');item.classList.add('pm-brick','pm-product-fact');row.append(item);});output.append(row);flush();}
     else{flush();walk(node);flush();}
     return;
    }
    if(node.matches('h1,h2,h3,h4,h5,h6'))flush();
    if(node.matches('p')&&!node.textContent.trim()&&!node.querySelector('img,iframe,video'))return;
    node.removeAttribute('style');add(node);
   });
  };
  walk(root);root.replaceChildren(output);
 });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build,{once:true});else build();
 document.addEventListener('shopify:section:load',build);
 let rowsQueued=false;
 const scheduleRows=()=>{if(rowsQueued)return;rowsQueued=true;requestAnimationFrame(()=>{rowsQueued=false;rows();});};
 const watch=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&!n.matches('.pm-mould-stud'))))scheduleRows();});
 const main=document.querySelector('#site-main');if(main)watch.observe(main,{childList:true,subtree:true});
})();
